import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue';
import CheckBox from "../../selection-controls/CheckBox.vue";
import SearchBar from "../../text-inputs/searchBar/SearchBar.vue"
import { Collection, SelectBoxItem, LabelStrings } from '../types';
import { clickItemHandler, selectedItemsLabelHandler } from "../multiSelectUtils";


export default /*#__PURE__*/_defineComponent({
  __name: 'MultiSelectSearch',
  props: {
    disabled: { type: Boolean },
    value: null,
    collections: null,
    labelStrings: null,
    errorMessage: null
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
  (e: "input", value?: SelectBoxItem[]): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  disabled?: boolean,
  value?: SelectBoxItem[],
  collections: Collection[],
  labelStrings: LabelStrings,
  errorMessage?: string,
};





// CONVERTED PROPS
const originalItems = computed(() =>
  props.collections.flatMap((collection:Collection) => collection.items)
);
const inRange = (num: number, a: number, b=0) => (Math.min(a,b) <= num && num < Math.max(a,b));
const isIndeterminate = ref(props?.value && inRange(props?.value?.length, 1, originalItems.value.length));

// SELECTED ITEMS
const selectedItems = computed({
  get: () => props.value ? props.value : [],
  set: (newValue) => {
    isIndeterminate.value = inRange(newValue.length, 1, originalItems.value.length);
    emit('input', newValue);
  }
});

// AVAILABLE ITEMS
const availableCollections = computed(() => {
  return props.value ? props.collections.map((collection:Collection) => {
    return {
      name: collection.name,
      items: collection.items.filter(item => !(selectedItems.value.some(value => value.value === item.value)))
    }
  }) : props.collections
})

const availableItems = computed(() => {
  return availableCollections.value.flatMap((collection:Collection) => collection.items)
})

// SEARCH
const currentSearchLower = computed(() => currentSearch.value.toLowerCase());

const searchResultItems = computed(
  () => {
    return availableItems.value.filter((item) => {
      const itemName = item.text.toLowerCase();
      return currentSearchLower.value ? itemName.indexOf(currentSearchLower.value) > -1 : false;
    });
  });

const isSelectedAll = computed({
  get: () => props?.value?.length === originalItems.value.length,
  set: (newValue) => {
    selectedItems.value = newValue ? originalItems.value : [];
  }
})

// SELECT ALL
const selectActive = ref<boolean>(false);

const currentSearch = ref<string>('');
// LABEL
const selectedItemsLabel = computed(() =>
  selectedItemsLabelHandler(isSelectedAll.value, selectedItems.value, props.labelStrings)
);

// EVENT HANDLERS
const hideMultiSelectItems = () => { selectActive.value = false; };

// Function responsible for removing/adding items allFilteredItems
const clickItem = (item: SelectBoxItem)  => {
  selectedItems.value = clickItemHandler(item, selectedItems.value);
}

watch(selectActive, (newValue, oldValue) => {
  if (!newValue && newValue !== oldValue) {
    currentSearch.value = '';
  }
});

return { __sfc: true,props, emit, originalItems, inRange, isIndeterminate, selectedItems, availableCollections, availableItems, currentSearchLower, searchResultItems, isSelectedAll, selectActive, currentSearch, selectedItemsLabel, hideMultiSelectItems, clickItem, CheckBox, SearchBar }
}

})